<ng-container *ngIf="inputText">
  <p
    for="title"
    [ngClass]="{ 'text-disabled': textDisable, legal: isLegalText, small: browseService }"
    [innerHTML]="showText"
  ></p>
  <!-- Updated Spacing As Per The Wireframe  -->
  <div [class.row]="!removeRowClass" *ngIf="!seeLess">
    <div
      [ngClass]="{ legal: isLegalText, 'col-11': !browseService }"
      class="m-t-sm"
      *ngIf="limit < inputText.length"
    >
      <a
        attr.aria-label="{{ seeMoreText }}"
        [ngClass]="{ disabled: browseService && textDisable }"
        href="javascript:void(0)"
        (click)="seeMoreClick()"
        id="cta-see-more-text"
        >{{ seeMoreText }}</a
      >
    </div>
  </div>
  <!-- Updated Spacing As Per The Wireframe  -->
  <div [class.row]="!removeRowClass" *ngIf="seeLess">
    <div
      [ngClass]="{ legal: isLegalText, 'col-11': !browseService }"
      class="m-t-sm"
      *ngIf="limit < inputText.length"
    >
      <a
        attr.aria-label="{{ seeLessText }}"
        href="javascript:void(0)"
        (click)="seeLessClick()"
        id="cta-see-less-text"
        >{{ seeLessText }}</a
      >
    </div>
  </div>
</ng-container>
